import styled from '@mui/material/styles/styled'

export const ScrollBox = styled('div', {
  name: 'ScrollBar',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  overflowX: 'hidden',
  overflowY: 'auto',
  maxHeight: '600px',
  height: '100%',
  '&::-webkit-scrollbar': {
    width: '16px',
    backgroundColor: theme.palette.common.white,
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.common.white,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#babac0',
    borderRadius: '16px',
    border: '4px solid theme.palette.primary.contrastText',
  },
  '&::-webkit-scrollbar-button': {
    display: 'none',
  },
}))
